import { Box, Typography, useTheme, Paper } from '@mui/material';

const InfoItem = ({ label, value }) => {
  const theme = useTheme();

  return (
    <Box sx={{ flex: 1, minWidth: 0, px: { xs: 1.5, md: 2 }, py: { xs: 1, md: 1.5 } }}>
      <Typography
        variant="overline"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: theme.typography.fontWeightBold,
          fontSize: '0.85rem',
          mb: 0.5,
        }}
      >
        {label}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontWeight: theme.typography.fontWeightRegular,
          color: theme.palette.text.primary,
          lineHeight: 1.3,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

const TurnoInfoCard = ({ nombreSede, fecha, hora, codigoMostrar }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        borderLeft: `6px solid ${theme.palette.primary.main}`,
        borderRadius: 1,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        backgroundColor: '#f8f8f8',
        py: 2,
      }}
    >
      <InfoItem label="Turno" value={codigoMostrar || 'N/A'} />
      <InfoItem label="Sede" value={nombreSede || 'N/A'} />
      <InfoItem label="Fecha y hora" value={fecha && hora ? `${fecha} ${hora}hs` : 'N/A'} />
    </Paper>
  );
};

export default TurnoInfoCard;
